import { render, staticRenderFns } from "./FullScreenContainer.vue?vue&type=template&id=0ae9a54c&"
import script from "./FullScreenContainer.vue?vue&type=script&lang=js&"
export * from "./FullScreenContainer.vue?vue&type=script&lang=js&"
import style0 from "./FullScreenContainer.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports